module.exports = __webpack_public_path__ + "5800309cc348687f69ccabc39de639e1.png";